import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state = { hasError: false };

  static getDerivedStateFromError = (): State => ({ hasError: true });

  componentDidCatch = (error: Error, errorInfo: ErrorInfo): void => {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  };

  render(): ReactNode {
    const { hasError } = this.state;
    const { fallback, children } = this.props;
    return hasError ? fallback : children;
  }
}

export default ErrorBoundary;
